/** @jsx jsx */

import { Fragment, ReactNode } from 'react';

import { Checkbox } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import Label from './Label';

export type Option = {
  checked: boolean;
  name: ReactNode;
  onKeyPress: (isSelected: boolean) => void;
  value: string;
};

type Props = {
  description?: string;
  isRequired?: boolean;
  options: Option[];
  title: string;
};

// TODO Zinnia v10: Use CheckboxGroup instead
function MultiSelectCheckboxes({
  description,
  isRequired,
  options,
  title,
}: Props) {
  return (
    <Fragment>
      {(title || description) && (
        <Label
          description={description}
          isRequired={isRequired}
          title={title}
        />
      )}
      {options.map(option => (
        <Checkbox
          isSelected={option.checked}
          onChange={option.onKeyPress}
          value={option.value}
        >
          {option.name}
        </Checkbox>
      ))}
    </Fragment>
  );
}

export default MultiSelectCheckboxes;
